module.exports = __webpack_public_path__ + "8673c7b5af638a7a9986847102bd2f8d.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/wei-anne.png
// module id = 586
// module chunks = 30